"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isElementInViewPort = exports.isElementVisible = void 0;
const MIN_PERCENTAGE = 0;
const MAX_PERCENTAGE = 100;
/**
 * Obtiene el valor porcentual del numero ingresado respecto de un minimo o un máximo
 * @param valueToSearch
 * @param min
 * @param max
 * @returns
 */
function isBetweenPercentage(valueToSearch, min, max) {
    return Math.round((valueToSearch < min ?
        min : valueToSearch > max ?
        max : valueToSearch) / max - min);
}
/**
 * Verifica si un elemento dentro de la página es visible (o al menos no está explicitamente oculto)
 */
function isElementVisible(window, element) {
    if (!window)
        return false;
    if (!element)
        return false;
    const style = window.getComputedStyle(element);
    return (style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0');
}
exports.isElementVisible = isElementVisible;
/**
 * Indica si un elemento se encuentra en la caja visible del navegador
 * @param visibilityPercentage porcentaje del elemento visible, de 0 a 100
 * @param visibilityAttributes evalua attributos que oculan al elemento
 * @todo Migrate to the browser optimized API to check elements
 */
function isElementInViewPort(window, element, visibilityPercentage = 40, visibilityAttributes = false) {
    var _a, _b;
    if (!window)
        return false;
    if (!element)
        return false;
    if (visibilityAttributes && !isElementVisible(window, element))
        return false;
    const elementBounds = element.getBoundingClientRect();
    if (!elementBounds)
        return false;
    const { innerWidth, innerHeight, document } = window;
    const { documentElement } = document;
    const windowWidth = (_a = innerWidth !== null && innerWidth !== void 0 ? innerWidth : documentElement === null || documentElement === void 0 ? void 0 : documentElement.clientWidth) !== null && _a !== void 0 ? _a : 0;
    const windowHeight = (_b = innerHeight !== null && innerHeight !== void 0 ? innerHeight : documentElement === null || documentElement === void 0 ? void 0 : documentElement.clientHeight) !== null && _b !== void 0 ? _b : 0;
    if (windowHeight === 0 || windowWidth === 0)
        return false;
    const { scrollY, scrollX, screen } = window;
    const { top, left, height, width } = elementBounds;
    const multiplyFactor = isBetweenPercentage(visibilityPercentage, MIN_PERCENTAGE, MAX_PERCENTAGE);
    const visibleTop = top + height * multiplyFactor;
    const visibleLeft = left + width * multiplyFactor;
    const currentScrollY = screen.height + scrollY;
    const currentScrollX = screen.width + scrollX;
    return visibleTop <= windowHeight && visibleLeft <= windowWidth || visibleTop <= currentScrollY && visibleLeft <= currentScrollX;
}
exports.isElementInViewPort = isElementInViewPort;
//# sourceMappingURL=visibility.js.map